/* eslint-disable */
import React, { Component } from 'react';
import AuthConnector from '../../containers/auth_container';
import {Button, Form, Grid, Image, Message, Segment, Header, Popup} from "semantic-ui-react";
import {updateUserEmail} from "../../data/user_api";
const user = JSON.parse(localStorage.getItem('user'));
class ChangeUserEmail extends Component {

    constructor(props){
        super(props);
        this.state = {
            showError:false,
            message:undefined,
            success:undefined,
            passwordMatch:undefined
        };

    }

    errorMessage = () => {
        return (
            <Message size='mini' negative onDismiss={() => {
                this.setState({showError: false})
            }}>
                <Message.Header>An Error Occured</Message.Header>
                <p>{this.state.message}</p>
            </Message>
        );
    };

    successMessage = () => {
        return (
            <Message size='mini' success>
                <Message.Header>Email Address Changed Successfully!!</Message.Header>
                {!this.props.userId && <p>You'll have to sign-in Again. You'll be redirected to sign-in page shortly</p>}
            </Message> )
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        updateUserEmail(formData).then((response)=>{
            if(response.status === 401){
                this.props.signOutAction();
            }
            if(response.success){
                this.setState({success:true,showError:false});
                if(!this.props.userId){
                    setTimeout(()=>{this.props.signOutAction()},3000);
                }
                else {
                    this.props.onSuccess?this.props.onSuccess():null
                }
            }
            else {
                this.setState({success:false,showError:true,message:response.error});
            }
        })
    };

    render(){
        const user = JSON.parse(localStorage.getItem('user'));
        return(
            <div className="login-form">
                <Grid textAlign='center' style={{height:'100%'}}>
                    <Grid.Column style={{maxWidth: 450}}>
                        {this.state.success && this.successMessage()}
                        {this.state.showError && this.errorMessage()}
                        {!this.state.success && <Form onSubmit={this.handleSubmit}>
                            <Segment>
                                {this.state.errorMessage && this.errorMessage()}
                                <Header content="Change Current Email" textAlign="center" />
                                <input type="hidden" name="user_id" value={this.props.userId ? this.props.userId :user['user_id']} />
                                <input type="hidden" name="current_user_id" value={user['user_id']} />
                                <p>Changing Email From : <b>{this.props.userEmail?this.props.userEmail:user.uid}</b></p>
                                <Form.Input fluid icon='at' iconPosition='left' placeholder='New Email'
                                            name="email" type="email" required/>
                                {!this.props.userId && <Form.Input fluid icon='lock' iconPosition='left' placeholder='Enter Current Password'
                                            type='password'  name="current_password"
                                            required={!this.props.userId}
                                />}
                                <Button primary fluid size='large'>Change E-Mail</Button>
                            </Segment>
                        </Form>}
                    </Grid.Column>
                </Grid>
            </div>
        )
    }
}

export default AuthConnector(ChangeUserEmail);


// WEBPACK FOOTER //
// ./src/views/auth/change_email.js